import React, { Fragment } from "react"
import styled from "styled-components"
import browserTest from "./browserTest"
// import websocketTest from "./websocketTest"
import { appDomain, appName } from "./domain"
const Frame = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: ${({ theme }) => theme.space.m};
    .resultColumn {
        min-height: 160px;
        width: 80vw;
    }
    .link {
        color: #4ebed7;
    }
`
const ErrorColumn = styled.div`
    width: 80vw;
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.space.s};
    background: ${({ theme }) => theme.color.background.m};
`
const Column = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.space.s};
    background: ${({ theme }) => theme.color.background.m};

    a {
        margin-left: auto;
        margin-right: auto;
    }
`
const ErrorUL = styled.ul`
    margin-top: 1em;
    margin-bottom: 1em;
    margin-left: 0.5em;
    li {
        list-style: disc;
        margin-left: 2em;
        margin-bottom: 0.5em;
        font-size: ${({ theme }) => theme.font.size.m};
    }
`

const Item = styled.div`
    display: flex;
    font-size: ${({ theme }) => theme.font.size.m};
    background: ${({ theme }) => theme.color.background.m};
    padding: 3px 20px 3px 20px;
`

const Heading = styled.span`
    font-size: ${({ theme }) => theme.font.size.l};
`

const Success = styled.span`
    color: ${({ theme }) => theme.color.success};
`

const Warning = styled.span`
    color: ${({ theme }) => theme.color.warning};
`

const Button = styled.button`
    font-size: ${({ theme }) => theme.font.size.m};

    margin-left: auto;
    margin-right: auto;
    margin-top: 12px;
    margin-bottom: 12px;
    padding-left: 12px;
    padding-right: 12px;
    font-size: ${({ theme }) => theme.font.size.l};
    border-radius: 3px;
    transition: ease-in-out 0.2s;

    background: ${({ theme }) => theme.color.background.l};
    &:hover {
        background: ${({ theme }) => theme.color.primaryLight};
    }
    &:active {
        background: ${({ theme }) => theme.color.background.l};
    }
`

const BrowserCheckWidget = () => {
    const checkResult = browserTest()
    if (!checkResult) {
        return (
            <Item>
                <Heading>
                    <Success>Success:&nbsp;</Success>Your current browser is
                    supported.
                </Heading>
            </Item>
        )
    }
    return (
        <Item>
            <Heading>
                <Warning>Warning:&nbsp;</Warning>
                {checkResult}{" "}
            </Heading>
        </Item>
    )
}

export default props => {
    if (!props.error && props.count === props.complete && !props.wsError) {
        return (
            <Frame>
                <Column className="resultColumn">
                    <Item>
                        <Heading>
                            <Success>Success:&nbsp;</Success>All resouces could
                            be reached.{" "}
                        </Heading>
                    </Item>
                    <BrowserCheckWidget />
                    <a
                        data-close-desktop-modal="true"
                        href={`https://${appDomain()}`}
                    >
                        <Button data-close-desktop-modal="true">
                            Go to {appName()}
                        </Button>
                    </a>
                </Column>
            </Frame>
        )
    } else {
        return (
            <Fragment>
                <Frame>
                    <ErrorColumn>
                        <BrowserCheckWidget />
                    </ErrorColumn>
                </Frame>
                {props.error && (
                    <Frame>
                        <ErrorColumn>
                            <Item>
                                <Heading>
                                    <Warning>Fail:&nbsp;</Warning>One or more
                                    HTTPS resources were not able to be reached.
                                </Heading>
                            </Item>
                            <Item>
                                <div>
                                    <br />
                                    This could prevent {appName()} from running
                                    correctly, or even prevent you from
                                    accessing the application at all..
                                    <br />
                                    <br />
                                </div>
                            </Item>
                        </ErrorColumn>
                    </Frame>
                )}
                {props.wsError && (
                    <Frame>
                        <ErrorColumn>
                            <Item>
                                <Heading>
                                    <Warning>Fail:&nbsp;</Warning>The{" "}
                                    {appName()} websocket endpoint could not be
                                    reached.
                                </Heading>
                            </Item>
                            <Item>
                                <div>
                                    <br />
                                    This will prevent {appName()} from loading
                                    your data or performing 3D prints.
                                    <br />
                                    <br />
                                </div>
                            </Item>
                        </ErrorColumn>
                    </Frame>
                )}
                {(props.wsError || props.error) && (
                    <Frame>
                        <ErrorColumn>
                            <Item>
                                <Heading>
                                    The most common problems causing these
                                    issues are
                                </Heading>
                                <br />
                            </Item>
                            <Item>
                                <div>
                                    <ErrorUL>
                                        <li>Non-whitelisted domains</li>
                                        <li>Misconfigured proxy settings</li>
                                        <li>Network connectivity issues</li>
                                        <li>A temporary internet outage</li>
                                    </ErrorUL>
                                    <br />
                                    <h2>Your next steps</h2>
                                    <br />
                                    <ErrorUL>
                                        <li>
                                            Ensure you have a good internet
                                            connection.
                                        </li>
                                        <li>
                                            Ensure your computer isn&apos;t
                                            blocking your internet traffic.
                                        </li>
                                        <li>
                                            Complicated network? You might need
                                            to get your IT administrator to set
                                            up a few things. See below.
                                        </li>
                                    </ErrorUL>
                                    <br />
                                    <h2>Instructions for IT Administrators</h2>
                                    <br />
                                    In larger network settings, you may need to
                                    allow your computer and CloudDock to talk to
                                    BuildBee services.
                                    <br />
                                    <ErrorUL>
                                        <li>
                                            <a
                                                target="_blank"
                                                rel="noreferrer noopener"
                                                className="link"
                                                href="https://support.buildbee.com/portal/kb/articles/it-domains-for-whitelisting"
                                            >
                                                Add BuildBee to the allowed
                                                sites on your network whitelist.
                                            </a>
                                        </li>
                                        <li>
                                            If you have a proxy, configure any
                                            proxy settings necessary for your
                                            network.
                                        </li>
                                        <li>
                                            If you have a proxy, ensure that
                                            both https and wss traffic is
                                            allowed.
                                        </li>
                                        <li>
                                            Note - In some cases, our{" "}
                                            <a
                                                target="_blank"
                                                rel="noreferrer noopener"
                                                className="link"
                                                href="https://support.buildbee.com/portal/kb/buildbee"
                                            >
                                                knowledge base
                                            </a>{" "}
                                            contains specialised instructions
                                            for school networks.{" "}
                                        </li>
                                        <br />
                                        <br />
                                        For more help and support,{" "}
                                        <a
                                            target="_blank"
                                            rel="noreferrer noopener"
                                            className="link"
                                            href="https://support.buildbee.com/portal/newticket    "
                                        >
                                            contact our support team
                                        </a>
                                    </ErrorUL>
                                    <br />
                                </div>
                            </Item>
                            <Button onClick={() => window.location.reload()}>
                                Retry
                            </Button>
                        </ErrorColumn>
                    </Frame>
                )}
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/ErrorMessage.js